import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";

export default function TooltipType({ title, children, placement = "top" }) {
  return (
    <MuiTooltip title={title} arrow placement={placement}>
      {children}
    </MuiTooltip>
  );
}
